import * as msit from '@microsoftit/telemetry-extensions-npm'; 
export class BusinessProcessEvent extends msit.BusinessProcessEvent {
    constructor(businessProcessName: string, componentType: msit.ComponentType, startDateTime?: Date, endDateTime?: Date, templateType?: string){
        super(businessProcessName, componentType, startDateTime, endDateTime, templateType); 
    }
}


